import { Link } from "react-router-dom";
import { newsList } from "@/mocks/news";

export default function NewsTicker() {
  return (
    <div className="w-full px-4 md:px-8 mt-8">
      <div className="flex items-center gap-3 bg-background-50 border border-background-200 rounded-lg overflow-hidden">
        <span className="shrink-0 inline-flex items-center gap-1.5 px-3 md:px-4 py-2.5 bg-accent-500 text-background-50 text-xs md:text-sm font-semibold">
          <i className="ri-flashlight-fill" />
          资讯快讯
        </span>
        <div className="overflow-hidden flex-1">
          <div className="flex animate-ticker whitespace-nowrap">
            {[...newsList, ...newsList].map((n, i) => (
              <Link
                key={`${n.id}-${i}`}
                to={`/news/${n.id}`}
                className="inline-flex items-center gap-2 px-4 md:px-6 text-xs md:text-sm text-foreground-700 hover:text-primary-600 transition-colors"
              >
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500 shrink-0" />
                {n.title}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}